import {useMutation, useQueryClient} from "@tanstack/react-query";
import { usePatientsContext } from "context/patient_context";
import editAgentProfile from "api/editAgentProfile";
import {queryKeys} from "../react-query/constant";

const useEditAgentProfile = () => {
  const queryClient = useQueryClient();
  const { handleOpenSnackbar } = usePatientsContext();
  const mutateAgent = useMutation({
    mutationFn: editAgentProfile,
    onSuccess: (res) => {
      if (res.status === 200) {
        queryClient.invalidateQueries(queryKeys.agentInfo);
        handleOpenSnackbar('اطلاعات با موفقیت ثبت شد');
      }
    },
    onError: (error) => {
      handleOpenSnackbar(error.response.data.messages, 'error');
    }
  });
  return mutateAgent;
};

export default useEditAgentProfile;